// Lib
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from '../../../../node_module_clones/react-router';

// Util
import { updateEmailPreferences } from './emailPreferenceService';

// Selectors
import { getUrlEmail, getUrlEmailType } from '../../../app/routingSelector';
import { navigateToAccountNotificationSettings } from '../../../reducers/navigationActions';

// Components
import FullScreenModal from '../../../components/modal/FullScreenModal';

import { EMAIL_PREFERENCE_UNSUBSCRIBE_DESCRIPTIONS } from '../accountConstants';

import './EmailUnsubscribeModal.scss';

const mapStateToProps = (state) => ({
    email: decodeURIComponent(getUrlEmail(state)),
    emailType: getUrlEmailType(state) && Number(getUrlEmailType(state)),
});

const mapDispatchToProps = (dispatch) => ({
    navigateToEmailSettings: () => dispatch(navigateToAccountNotificationSettings()),
});

const EmailUnsubscribeFullscreenModal = ({ email, emailType, navigateToEmailSettings }) => {
    const emailTypeDetail = EMAIL_PREFERENCE_UNSUBSCRIBE_DESCRIPTIONS.find(({ value }) => value === emailType);

    const unsubscribeFromEmailType = () => {
        updateEmailPreferences({
            email,
            unsubscribeType: emailType,
        });
    };

    useEffect(() => {
        if (emailType && emailTypeDetail) {
            unsubscribeFromEmailType();
        } else {
            // if an email type to unsubscribe from is not specified,
            // forward to notification preferences
            navigateToEmailSettings();
        }
    }, []);

    return (
        <FullScreenModal className="EmailUnsubscribeModal">
            <div>
                <h1>Unsubscribe successful</h1>

                {emailType && emailTypeDetail && (
                    <p className="notification-description">We&apos;ll stop sending you {emailTypeDetail?.label}</p>
                )}

                <p>
                    <Link to="/account/notifications">Edit your notification preferences</Link>
                </p>
            </div>
        </FullScreenModal>
    );
};

EmailUnsubscribeFullscreenModal.propTypes = {
    email: PropTypes.string,
    emailType: PropTypes.number,
    isGuest: PropTypes.bool,
    navigateToEmailSettings: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(EmailUnsubscribeFullscreenModal);
